module.exports = __webpack_public_path__ + "img/D201901_2.d708980b.jpg";